<template>
  <v-row dense>      
    <v-col cols="1"></v-col>
    <v-col cols="1" v-for="(day, i) in days" :key="i">
      <v-label><span class="day-labels ml-1">{{ day }}</span></v-label>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    data() {
      return {
        days: ["Su","Mo","Tu","We","Th","Fr","Sa"],
      }
    }, 
  }
</script>

<style scoped>
  .day-labels {
    font-weight: 600 !important;
  }
</style>